import React, { useState, useEffect } from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import styled from "@emotion/styled";
import { Tooltip } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";

const CustomToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  "&.MuiToggleButtonGroup-root": {
    background: "#eef4ff",
    marginBottom: "20px",
    borderRadius: "50px",
  },
  "&.MuiToggleButtonGroup-root button:first-child": {
    borderTopLeftRadius: "50px",
    borderBottomLeftRadius: "50px",
    border: "none",
    paddingLeft: "20px",
    paddingRight: "20px",
  },
  "&.MuiToggleButtonGroup-root button:last-child": {
    borderTopRightRadius: "50px",
    borderBottomRightRadius: "50px",
    border: "none",
    paddingLeft: "20px",
    paddingRight: "20px",
  },
  "& .MuiToggleButton-root": {
    textTransform: "none",
    fontWeight: "normal",

    "&.Mui-selected": {
      backgroundColor: "#fff",
      color: "#000",
      fontWeight: "bold",
      borderRadius: "50px",
      border: "1px solid #000",
      boxShadow: "0px 0px 1px 1px #bbbbbb",
      "&:hover": {
        backgroundColor: "#fff !important",
      },
    },
  },
}));

function ViewToggle() {
  const location = useLocation(); // Get current route
  const [view, setView] = useState("cohort");

  // Sync state with current route
  useEffect(() => {
    if (location.pathname === "/assign-task-cohort") {
      setView("cohort");
    } else if (location.pathname === "/all-vendors") {
      setView("vendors");
    }
  }, [location.pathname]);

  const handleViewChange = (event: any, newView: any) => {
    if (newView !== null) {
      setView(newView);
    }
  };
  console.log(location, "locationlocationlocationlocation")
  return (
    <CustomToggleButtonGroup
      value={view}
      exclusive
      onChange={handleViewChange}
      aria-label="view toggle"
    >
      <Tooltip title="Cohort View" arrow>
        <ToggleButton value="cohort">
          <NavLink
            to="/assign-task-cohort"
            style={({ isActive }) => ({
              color: isActive ? "#000" : "#696A6B",
              textDecoration: "none",
            })}
          >
            Cohort View
          </NavLink>
        </ToggleButton>
      </Tooltip>
      <Tooltip title="All Vendors" arrow>
        <ToggleButton value="vendors">
          <NavLink
            to="/all-vendors"
            style={({ isActive }) => ({
              color: isActive ? "#000" : "#696A6B",
              textDecoration: "none",
            })}
          >
            All Vendors
          </NavLink>
        </ToggleButton>
      </Tooltip>
    </CustomToggleButtonGroup>
  );
}

export default ViewToggle;
